import { Record } from 'immutable';

const PrepaymentSummaryRecord = Record({

  amount: null,
  description: null,

});

export class PrepaymentSummary extends PrepaymentSummaryRecord {

  amount: number;
  description: string;

}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-summary/prepayment-summary.ts